function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { forwardRef } from 'react';
import { withIconWrapper } from '../../components/atoms/Icon/withIconWrapper';
import { jsx as ___EmotionJSX } from "@emotion/react";

var VectorLogoBCB = function VectorLogoBCB(props, ref) {
  return ___EmotionJSX("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "21.1 12.2 165.2 90.2",
    fill: "currentColor",
    stroke: "none",
    ref: ref
  }, props), ___EmotionJSX("g", null, ___EmotionJSX("g", null, ___EmotionJSX("rect", {
    x: "39.8",
    y: "56.9",
    width: "2.6",
    height: "2.6"
  }), ___EmotionJSX("rect", {
    x: "40.9",
    y: "49.2",
    width: "2.6",
    height: "2.6"
  }), ___EmotionJSX("rect", {
    x: "44.1",
    y: "42",
    width: "3",
    height: "3"
  }), ___EmotionJSX("rect", {
    x: "49.4",
    y: "36.2",
    width: "3",
    height: "3"
  }), ___EmotionJSX("rect", {
    x: "56.2",
    y: "32.3",
    width: "3",
    height: "3"
  }), ___EmotionJSX("rect", {
    x: "57.2",
    y: "82.1",
    width: "0.9",
    height: "0.9"
  }), ___EmotionJSX("rect", {
    x: "49.9",
    y: "77.7",
    width: "1.9",
    height: "1.9"
  }), ___EmotionJSX("rect", {
    x: "44.5",
    y: "71.8",
    width: "2.2",
    height: "2.2"
  }), ___EmotionJSX("rect", {
    x: "40.9",
    y: "64.6",
    width: "2.6",
    height: "2.6"
  }), ___EmotionJSX("rect", {
    x: "30",
    y: "55.9",
    width: "4.6",
    height: "4.6"
  }), ___EmotionJSX("rect", {
    x: "30.9",
    y: "48.1",
    width: "4.6",
    height: "4.6"
  }), ___EmotionJSX("rect", {
    x: "34.2",
    y: "41.5",
    width: "3.1",
    height: "3.1"
  }), ___EmotionJSX("rect", {
    x: "38.2",
    y: "34.7",
    width: "3.4",
    height: "3.4"
  }), ___EmotionJSX("rect", {
    x: "43.7",
    y: "29.2",
    width: "3.5",
    height: "3.5"
  }), ___EmotionJSX("rect", {
    x: "50.5",
    y: "25.2",
    width: "3.2",
    height: "3.2"
  }), ___EmotionJSX("rect", {
    x: "57.8",
    y: "22.6",
    width: "3.2",
    height: "3.2"
  }), ___EmotionJSX("rect", {
    x: "65.4",
    y: "21.5",
    width: "3.6",
    height: "3.6"
  }), ___EmotionJSX("rect", {
    x: "72.1",
    y: "21.3",
    width: "5.8",
    height: "5.8"
  }), ___EmotionJSX("rect", {
    x: "79.3",
    y: "23.8",
    width: "6",
    height: "6"
  }), ___EmotionJSX("rect", {
    x: "86.8",
    y: "28.8",
    width: "4.3",
    height: "4.3"
  }), ___EmotionJSX("rect", {
    x: "58.7",
    y: "91.5",
    width: "1.5",
    height: "1.5"
  }), ___EmotionJSX("rect", {
    x: "51.3",
    y: "88.9",
    width: "1.5",
    height: "1.5"
  }), ___EmotionJSX("rect", {
    x: "44.5",
    y: "84.6",
    width: "1.9",
    height: "1.9"
  }), ___EmotionJSX("rect", {
    x: "38.8",
    y: "78.9",
    width: "2.2",
    height: "2.2"
  }), ___EmotionJSX("rect", {
    x: "34.6",
    y: "72.1",
    width: "2.4",
    height: "2.4"
  }), ___EmotionJSX("rect", {
    x: "31.7",
    y: "64.5",
    width: "3",
    height: "3"
  }), ___EmotionJSX("rect", {
    x: "21.1",
    y: "55.7",
    width: "5",
    height: "5"
  }), ___EmotionJSX("rect", {
    x: "22.1",
    y: "48.3",
    width: "5",
    height: "5"
  }), ___EmotionJSX("rect", {
    x: "24.7",
    y: "41.2",
    width: "3.4",
    height: "3.4"
  }), ___EmotionJSX("rect", {
    x: "27.9",
    y: "34",
    width: "3.7",
    height: "3.7"
  }), ___EmotionJSX("rect", {
    x: "32.8",
    y: "28",
    width: "3.7",
    height: "3.7"
  }), ___EmotionJSX("rect", {
    x: "38.4",
    y: "22.5",
    width: "4",
    height: "4"
  }), ___EmotionJSX("rect", {
    x: "44.9",
    y: "18.2",
    width: "3.9",
    height: "3.9"
  }), ___EmotionJSX("rect", {
    x: "52.8",
    y: "15.7",
    width: "2",
    height: "2"
  }), ___EmotionJSX("rect", {
    x: "58.6",
    y: "12.2",
    width: "5.6",
    height: "5.6"
  }), ___EmotionJSX("rect", {
    x: "66.7",
    y: "12.2",
    width: "4.8",
    height: "4.8"
  }), ___EmotionJSX("rect", {
    x: "75.3",
    y: "14",
    width: "3.3",
    height: "3.3"
  }), ___EmotionJSX("rect", {
    x: "81.5",
    y: "15.2",
    width: "5.8",
    height: "5.8"
  }), ___EmotionJSX("rect", {
    x: "88.5",
    y: "19.1",
    width: "5.4",
    height: "5.4"
  }), ___EmotionJSX("rect", {
    x: "94.5",
    y: "23.8",
    width: "5.8",
    height: "5.8"
  }), ___EmotionJSX("rect", {
    x: "68.6",
    y: "101.2",
    width: "1.2",
    height: "1.2"
  }), ___EmotionJSX("rect", {
    x: "60.8",
    y: "100.9",
    width: "1",
    height: "1"
  }), ___EmotionJSX("rect", {
    x: "53.1",
    y: "99.1",
    width: "1.3",
    height: "1.3"
  }), ___EmotionJSX("rect", {
    x: "45.8",
    y: "95.9",
    width: "1.5",
    height: "1.5"
  }), ___EmotionJSX("rect", {
    x: "39.2",
    y: "91.5",
    width: "1.7",
    height: "1.7"
  }), ___EmotionJSX("rect", {
    x: "33.5",
    y: "86.1",
    width: "1.7",
    height: "1.7"
  }), ___EmotionJSX("rect", {
    x: "28.5",
    y: "79.3",
    width: "2.5",
    height: "2.5"
  }), ___EmotionJSX("rect", {
    x: "25",
    y: "72.2",
    width: "2.7",
    height: "2.7"
  }), ___EmotionJSX("rect", {
    x: "22.7",
    y: "64.4",
    width: "3.1",
    height: "3.1"
  })), ___EmotionJSX("g", null, ___EmotionJSX("g", null, ___EmotionJSX("path", {
    d: "M93.7,56.5l0.8,0.6c-2,2.9-5.4,4.9-9.2,4.9c-6.1,0-11.1-4.9-11.1-11.1s4.9-11.1,11.1-11.1 c3.8,0,7.2,1.9,9.2,4.9l-0.8,0.6c-1.8-2.7-4.9-4.5-8.4-4.5c-5.6,0-10.1,4.5-10.1,10.1S79.7,61,85.3,61 C88.8,60.9,91.9,59.2,93.7,56.5z"
  }), ___EmotionJSX("path", {
    d: "M99.6,38.4h1v23.4h-1V38.4z"
  }), ___EmotionJSX("path", {
    d: "M119.8,49.8v-4.3h1v16.4h-1v-4.4c-1.3,2.9-4.2,4.4-7,4.4c-3.9,0-8-3-8-8.3s4.2-8.3,8-8.3 C115.5,45.3,118.4,46.9,119.8,49.8z M119.8,53.6c0-4.6-3.6-7.3-7-7.3s-7,2.7-7,7.3s3.6,7.3,7,7.3 C116.2,60.9,119.8,58.2,119.8,53.6z"
  }), ___EmotionJSX("path", {
    d: "M138.5,45.4h1v16.4h-1v-3.7c-0.7,1.9-3.5,3.8-6.7,3.8c-3.8,0-5.7-2.2-5.7-7v-9.4h1v9.4 c0,4.3,1.4,6.1,4.8,6.1c3.3,0,5.8-2.1,6.5-4.9L138.5,45.4L138.5,45.4z"
  }), ___EmotionJSX("path", {
    d: "M158.7,49.8V38.4h1v23.4h-1v-4.4c-1.3,2.9-4.2,4.4-7,4.4c-3.9,0-8-3-8-8.3s4.2-8.3,8-8.3 C154.5,45.3,157.4,46.9,158.7,49.8z M158.7,53.6c0-4.6-3.6-7.3-7-7.3s-7,2.7-7,7.3s3.6,7.3,7,7.3 C155.1,60.9,158.7,58.2,158.7,53.6z"
  }), ___EmotionJSX("path", {
    d: "M179.9,54h-15c0.2,4.4,3.7,6.9,7,6.9c2.7,0,4.8-1.2,6.4-2.8l0.8,0.6c-1.8,1.8-4.2,3.1-7.2,3.1 c-3.9,0-8-3-8-8.3s4.1-8.3,8-8.3C176.5,45.3,180.3,49.3,179.9,54z M164.9,53.1h14c-0.1-4.1-3.8-6.7-7-6.7 C168.6,46.3,165.2,48.8,164.9,53.1z"
  })), ___EmotionJSX("g", null, ___EmotionJSX("path", {
    d: "M79.4,75.2c2.6,0.6,4.6,2.7,4.6,5.2c0,3.4-2.8,6-6.5,6h-9.9v-22h9.2c3.6,0,6.4,2.6,6.4,5.7 C83.1,72.2,81.8,74.5,79.4,75.2L79.4,75.2z M70.5,66.9v7.2h5.9c2.2,0,3.9-1.6,3.9-3.6c0-2.1-1.9-3.6-4.2-3.6H70.5z M70.5,83.9 h6.1c2.4,0,4.4-1.5,4.4-3.7c0-2.1-2-3.7-4.3-3.7h-6.2V83.9z"
  }), ___EmotionJSX("path", {
    d: "M103.4,79.1H89.5c0.5,2.9,2.9,4.7,5.4,4.7c2,0,3.9-1,5-2.6l2.6,1.4c-1.6,2.5-4.5,3.9-7.6,3.9 c-4.2,0-8.5-3-8.5-8.4s4.3-8.4,8.5-8.4C100.1,69.6,103.9,73.6,103.4,79.1z M89.6,76.6h10.7c-0.2-2.6-3-4.3-5.4-4.3 C92.4,72.3,90.2,73.9,89.6,76.6z"
  }), ___EmotionJSX("path", {
    d: "M109.8,72.9c0.5-1.8,3-3.3,6.7-3.3v2.8c-3.9-0.3-6.1,1.6-6.7,4.5v9.4h-3V69.7h3V72.9z"
  }), ___EmotionJSX("path", {
    d: "M134,76.6v9.7h-3v-9.1c0-3.4-1.1-4.9-3.9-4.9c-2.6,0-4.5,1.7-5,4v10h-3V69.7h3v3c0.8-1.7,3.4-3.2,6.3-3.1 C132,69.8,134,72.3,134,76.6z"
  }), ___EmotionJSX("path", {
    d: "M151.4,72.5v-2.8h3v16.6h-3v-2.7c-1.3,1.8-3.4,2.8-5.5,2.8c-4.2,0-8.5-3.1-8.5-8.4c0-5.4,4.3-8.4,8.5-8.4 C148,69.6,150.2,70.6,151.4,72.5z M151.4,78c0-3.5-2.7-5.8-5.5-5.8s-5.5,2.3-5.5,5.8s2.7,5.8,5.5,5.8 C148.6,83.8,151.4,81.5,151.4,78z"
  }), ___EmotionJSX("path", {
    d: "M161.6,72.9c0.5-1.8,3-3.3,6.7-3.3v2.8c-3.9-0.3-6.1,1.6-6.7,4.5v9.4h-3V69.7h3V72.9z"
  }), ___EmotionJSX("path", {
    d: "M183.3,72.5V63h3v23.4h-3v-2.7c-1.3,1.8-3.4,2.8-5.5,2.8c-4.2,0-8.5-3.1-8.5-8.4c0-5.4,4.3-8.4,8.5-8.4 C179.9,69.6,182.1,70.6,183.3,72.5z M183.3,78c0-3.5-2.7-5.8-5.5-5.8s-5.5,2.3-5.5,5.8s2.7,5.8,5.5,5.8S183.3,81.5,183.3,78z"
  })))));
};

export default withIconWrapper( /*#__PURE__*/forwardRef(VectorLogoBCB));
//# sourceMappingURL=VectorLogoBCB.js.map